import React, { useState, useEffect } from 'react';
import { Form, Button, Input, Checkbox } from 'antd';
import { usePopupManager } from 'react-popup-manager';
import { B2cOperatorEditModal } from 'components/molecules';

interface FormItemProps {
  form: any;
  group_srl: number;
  operator?: string;
  schedule_date?: string;
}

const DailyOperatorFormItem = ({form, group_srl = 0, operator='', schedule_date=''}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [operators, setOperators] = useState<string>(operator);
  const { open } = usePopupManager();

  /* ======================================================
  * hooks
  * ====================================================== */

  /* ======================================================
  * events
  * ====================================================== */  
  const onOperatorEditPopup = (group_srl: number) => {
    open(B2cOperatorEditModal, {
      group_srl: group_srl,
      schedule_date: schedule_date,
      onClose: (isOk, op) => {
        if (isOk) {
          setOperators(op);
        }
      },
    }); 
   }

   useEffect(() => {

    setOperators(operator);
   }, [operator])
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="need_operater_yn" valuePropName="checked" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Checkbox>운영자 필요여부</Checkbox>                
      </Form.Item> 
      <Form.Item name="need_operater_num" style={{ width:'100px', display: 'inline-block', marginRight: '5px' }}>
        <Input type="number" placeholder='필요인원'/>  
      </Form.Item> 
      {(group_srl > 0) && (
        <Form.Item style={{ display: 'inline-block', marginRight: '5px' }}>
          {/*<Button type="primary" style={{ marginRight: '5px'}} onClick={()=>onOperatorEditPopup(group_srl)}>운영자배정</Button>*/}  
          <label>{operators}</label>
        </Form.Item>               
      )}     
    </>
  );
};

export default DailyOperatorFormItem;
